import Component from "vue-class-component";
import Vue from "vue";
import { namespace } from "vuex-class";
import { ACTION_TYPES } from "@/lib/const";
import { TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";
import { StateTags } from "@/store/types";

export const storePath = "tags";
const Store = namespace(storePath);

const { SET_DATA, DEL_DATA, ADD_DATA, GET_DATA } = ACTION_TYPES;

@Component({ name: "WithTags" })
export default class WithTags extends Vue {
  @Store.State(state => state)
  public readonly state!: StateTags;

  @Store.Action(SET_DATA)
  public tagsUpdate!: (tag: TagInfo) => Promise<TagInfo>;

  @Store.Action(DEL_DATA)
  public tagsDelete!: (id: string) => Promise<boolean>;

  @Store.Action(ADD_DATA)
  public tagsCreate!: (title: string) => Promise<TagInfo>;

  @Store.Action(GET_DATA)
  public tagsGet!: () => Promise<TagInfo[]>;
}
